import React, { useEffect, useState } from "react";
import "./MyStyles/style.css";
import "./MyStyles/responsive.css";

export const FAQs = () => {
  // State to manage which FAQ is open
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    // If the clicked item is already open, close it. Otherwise, open it.
    setOpenIndex(openIndex === index ? null : index);
  };

  // Array of FAQ questions and answers
  const faqs = [
    {
      question: "How many codes can I buy?",
      answer:
        "You can buy minimum of 10 and maximum of 25 codes in one transaction.",
    },
    {
      question: "Can I make buy codes more than once with same mobile no?",
      answer:
        "Yes, in each transaction, you can buy minimum of 10 and maximum of 25 codes.",
    },
    {
      question: "Can I distribute the codes to others ?",
      answer:
        "Yes, code can be redeemed by the recipient of the code, even if the same is purchased by you.",
    },
    {
      question: "Can anyone get subscription by applying the code received ?",
      answer:
        "Anyone who does not have an existing active or expired subscription of vzy can avail subscription with this code.",
    },
    {
      question: "I am being asked to save my credit and debit card details.",
      answer:
        "Yes, no charges will be deducted from your Credit / debit card.You will get 1 month subscription, post that plan will auto renew at pack MRP until opted out.",
    },
  ];

  useEffect(() => {}, [openIndex]);

  return (
    <div className="container faqContainer">
      <div className="padding-top-btm ">
        <h2 className="faq-title">FAQ’s</h2>
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className={`faq-question ${openIndex === index ? "active" : ""}`}
              onClick={() => handleToggle(index)}
            >
              <span>{faq.question}</span>
              <i className="fas fa-chevron-down"></i>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
